import { DeltaChip, type DeltaChipProps } from "./DeltaChip";

export interface MetricTileProps {
  /** "Ingreso", "Presupuesto". */
  label: string;
  /** Cifra ya formateada ("$3,500"). */
  value: string;
  /** Cambio frente a otro periodo. */
  delta?: Omit<DeltaChipProps, "onCard" | "size">;
  /** En lugar del cambio: nota corta en píldora con contorno ("58% usado"). */
  note?: string;
}

/** Cifra secundaria sobre `surface-raised` con rótulo en versalitas y una píldora de contexto. */
export function MetricTile({ label, value, delta, note }: MetricTileProps) {
  return (
    <article
      aria-label={`${label}, ${value}`}
      className="flex items-start justify-between gap-3 rounded-[var(--ds-radius-lg)] bg-[var(--ds-surface-raised)] px-5 py-4 text-[var(--ds-ink)]"
    >
      <div className="min-w-0">
        <div className="text-[11px] font-medium uppercase leading-[14px] tracking-[0.14em] text-[var(--ds-ink-muted)]">{label}</div>
        <div className="mt-1 font-[var(--ds-font-display)] text-[32px] leading-[40px] tracking-[-0.035em] md:text-[44px] md:leading-[48px]">{value}</div>
        {(delta || note) && (
          <div className="mt-2">
            {delta ? (
              <DeltaChip {...delta} size="sm" />
            ) : (
              <span className="inline-flex h-6 items-center whitespace-nowrap rounded-[var(--ds-radius-pill)] border-[1.5px] border-solid border-current px-2 text-xs font-medium leading-none text-[var(--ds-ink-muted)]">
                {note}
              </span>
            )}
          </div>
        )}
      </div>
    </article>
  );
}
